import { ElectronAPI } from '../base/ElectronAPI';

import type { ChromeImportResponse } from '../../../../electron/shared/chrome-import.types';

export class ChromeImportAPI extends ElectronAPI {
  get available(): boolean {
    return (
      this.isElectronAvailable &&
      ['darwin', 'linux'].includes(window.systemInfo?.platform)
    );
  }

  async importPasswords(): Promise<ChromeImportResponse> {
    if (!this.available) return { kind: 'error' };
    return this.mainProcessApi.chromeImport();
  }
}
